import React, { Component } from "react";
import { Button, Container, Row, Col, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../../config.json";
// import CryptoJS from "crypto-js";
import BulkImportWizard from "./BulkImportWizard";
import "./BulkImport.css";

export default class BulkImport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showWizard: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      filteredData: null,
      currentSession: null,

      tableClms: [
        {
          name: "Session Code",
          id: "session_code",
          selector: (row) => row.session_code,
          sortable: true,
          width: "140px",
          cell: (row) => (
            <span className="fw-bold text-primary">{row.session_code}</span>
          ),
        },
        {
          name: "Session Name",
          id: "session_name",
          selector: (row) => row.session_name,
          sortable: true,
          cell: (row) => <span>{row.session_name || row.file_name}</span>,
        },
        {
          name: "Target Table",
          id: "target_table",
          selector: (row) => row.target_table,
          sortable: true,
          cell: (row) => (
            <span className="badge bg-info">{row.target_table}</span>
          ),
        },
        {
          name: "File Info",
          id: "file_name",
          selector: (row) => row.file_name,
          sortable: true,
          cell: (row) => (
            <div>
              <div className="fw-semibold">{row.file_name}</div>
              <small className="text-muted">
                {this.formatFileSize(row.file_size)} •{" "}
                {row.file_type?.toUpperCase()}
              </small>
            </div>
          ),
        },
        {
          name: "Progress",
          id: "progress",
          selector: (row) => row.processed_rows,
          sortable: true,
          cell: (row) => (
            <div className="text-center">
              <div className="small">
                {row.processed_rows || 0} / {row.total_rows || 0}
              </div>
              <div
                className="progress"
                style={{ width: "80px", height: "6px" }}
              >
                <div
                  className="progress-bar bg-primary"
                  style={{
                    width: `${
                      row.total_rows > 0
                        ? ((row.processed_rows || 0) / row.total_rows) * 100
                        : 0
                    }%`,
                  }}
                ></div>
              </div>
            </div>
          ),
        },
        {
          name: "Results",
          id: "results",
          selector: (row) => row.success_count,
          sortable: true,
          cell: (row) => (
            <div className="text-center">
              <div
                className="d-flex justify-content-between"
                style={{ width: "80px" }}
              >
                <span className="badge bg-success small">
                  {row.success_count || 0}
                </span>
                <span className="badge bg-danger small">
                  {row.failed_count || 0}
                </span>
              </div>
              <small className="text-muted">Success / Failed</small>
            </div>
          ),
        },
        {
          name: "Status",
          id: "status",
          selector: (row) => row.status,
          sortable: true,
          cell: (row) => (
            <span className={`status-badge ${row.status}`}>{row.status}</span>
          ),
        },
        {
          name: "Created On",
          id: "created_on",
          selector: (row) => row.created_on,
          sortable: true,
          cell: (row) => (
            <div>
              <div>{new Date(row.created_on).toLocaleDateString()}</div>
              <small className="text-muted">
                {new Date(row.created_on).toLocaleTimeString()}
              </small>
            </div>
          ),
        },
        {
          name: "Actions",
          id: "actions",
          cell: (row) => (
            <div className="d-flex gap-2">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => this.viewSession(row)}
                title="View Details"
              >
                <i className="fas fa-eye"></i>
              </Button>

              {row.status === "completed" && row.result_file_path && (
                <Button
                  variant="outline-success"
                  size="sm"
                  onClick={() => this.downloadReport(row)}
                  title="Download Report"
                >
                  <i className="fas fa-download"></i>
                </Button>
              )}

              {(row.status === "failed" || row.status === "cancelled") && (
                <Button
                  variant="outline-warning"
                  size="sm"
                  onClick={() => this.resumeSession(row)}
                  title="Resume Import"
                >
                  <i className="fas fa-play"></i>
                </Button>
              )}

              {row.status === "processing" && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => this.cancelSession(row)}
                  title="Cancel Import"
                >
                  <i className="fas fa-stop"></i>
                </Button>
              )}
            </div>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchHandler();

    // Auto-refresh every 5 seconds for processing imports
    this.refreshInterval = setInterval(() => {
      const hasProcessing = this.state.data.some(
        (item) => item.status === "processing"
      );
      if (hasProcessing) {
        this.fetchHandler();
      }
    }, 5000);
  }

  componentWillUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  fetchHandler = () => {
    const data = new FormData();
    data.append("sId", this.state.sId);

    fetch(configData.api_url + "C_BulkImport/history", {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.status === "success") {
          this.setState({
            data: json.history || [],
            filteredData: json.history || [],
          });
        } else {
          this.showToast(
            json.message || "Failed to fetch import history",
            "error"
          );
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.showToast("Network error occurred", "error");
      });
  };

  showToast = (message, type = "success") => {
    if (type === "success") {
      toast.success(message);
    } else {
      toast.error(message);
    }
  };

  formatFileSize = (bytes) => {
    if (!bytes) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  startNewImport = () => {
    this.setState({ showWizard: true, currentSession: null });
  };

  closeWizard = () => {
    this.setState({ showWizard: false, currentSession: null });
    this.fetchHandler(); // Refresh the list
  };

  viewSession = (session) => {
    this.setState({ showWizard: true, currentSession: session });
  };

  downloadReport = (session) => {
    window.open(
      `${configData.api_url}C_BulkImport/download_report?session_id=${session.import_session_Id}`,
      "_blank"
    );
  };

  resumeSession = (session) => {
    const data = new FormData();
    data.append("sId", this.state.sId);
    data.append("session_id", session.import_session_Id);

    fetch(configData.api_url + "C_BulkImport/process", {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.status === "success") {
          this.showToast("Import resumed successfully");
          this.fetchHandler();
        } else {
          this.showToast(json.message || "Failed to resume import", "error");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.showToast("Network error occurred", "error");
      });
  };

  cancelSession = (session) => {
    if (!window.confirm("Are you sure you want to cancel this import?")) {
      return;
    }

    const data = new FormData();
    data.append("sId", this.state.sId);
    data.append("session_id", session.import_session_Id);

    fetch(configData.api_url + "C_BulkImport/cancel", {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.status === "success") {
          this.showToast("Import cancelled successfully");
          this.fetchHandler();
        } else {
          this.showToast(json.message || "Failed to cancel import", "error");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.showToast("Network error occurred", "error");
      });
  };

  handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm === "") {
      this.setState({ filteredData: this.state.data });
    } else {
      const filtered = this.state.data.filter(
        (item) =>
          item.session_code?.toLowerCase().includes(searchTerm) ||
          item.session_name?.toLowerCase().includes(searchTerm) ||
          item.file_name?.toLowerCase().includes(searchTerm) ||
          item.target_table?.toLowerCase().includes(searchTerm) ||
          item.status?.toLowerCase().includes(searchTerm)
      );
      this.setState({ filteredData: filtered });
    }
  };

  getStatistics = () => {
    const { data } = this.state;
    return {
      total: data.length,
      completed: data.filter((item) => item.status === "completed").length,
      processing: data.filter((item) => item.status === "processing").length,
      failed: data.filter((item) => item.status === "failed").length,
      totalRecords: data.reduce((sum, item) => sum + (item.total_rows || 0), 0),
      successfulRecords: data.reduce(
        (sum, item) => sum + (item.success_count || 0),
        0
      ),
    };
  };

  render() {
    const { filteredData, showWizard, currentSession } = this.state;
    const stats = this.getStatistics();

    if (showWizard) {
      return (
        <BulkImportWizard
          session={currentSession}
          onClose={this.closeWizard}
          sId={this.state.sId}
          uId={this.state.uId}
        />
      );
    }

    return (
      <div className="bulk-import-container">
        <Container fluid>
          {/* Header */}
          <Row className="mb-4">
            <Col>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h2 className="mb-1">
                    <i className="fas fa-upload me-2 text-primary"></i>
                    Bulk Import System
                  </h2>
                  <p className="text-muted mb-0">
                    Upload and manage large data imports with comprehensive
                    error tracking
                  </p>
                </div>
                <Button
                  variant="primary"
                  size="lg"
                  onClick={this.startNewImport}
                  className="btn-primary-custom"
                >
                  <i className="fas fa-plus me-2"></i>
                  New Import
                </Button>
              </div>
            </Col>
          </Row>

          {/* Statistics Cards */}
          <Row className="mb-4">
            <Col md={3} sm={6} className="mb-3">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center">
                  <div className="stat-number total">{stats.total}</div>
                  <div className="stat-label">Total Imports</div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={6} className="mb-3">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center">
                  <div className="stat-number success">{stats.completed}</div>
                  <div className="stat-label">Completed</div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={6} className="mb-3">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center">
                  <div className="stat-number" style={{ color: "#17a2b8" }}>
                    {stats.processing}
                  </div>
                  <div className="stat-label">Processing</div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={6} className="mb-3">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center">
                  <div className="stat-number failed">{stats.failed}</div>
                  <div className="stat-label">Failed</div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Search and Filters */}
          <Row className="mb-3">
            <Col md={6}>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search imports by session code, file name, table, or status..."
                  onChange={this.handleSearch}
                />
              </div>
            </Col>
            <Col md={6} className="text-end">
              <div className="text-muted small">
                Showing {filteredData?.length || 0} of {this.state.data.length}{" "}
                imports
              </div>
            </Col>
          </Row>

          {/* Data Table */}
          <Row>
            <Col>
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-0">
                  <DataTable
                    columns={this.state.tableClms}
                    data={filteredData}
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    highlightOnHover
                    striped
                    responsive
                    noDataComponent={
                      <div className="text-center py-5">
                        <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                        <h5 className="text-muted">No import sessions found</h5>
                        <p className="text-muted">
                          Start your first bulk import by clicking the "New
                          Import" button
                        </p>
                      </div>
                    }
                    customStyles={{
                      headCells: {
                        style: {
                          backgroundColor: "#f8f9fa",
                          fontWeight: "bold",
                          fontSize: "0.9rem",
                          color: "#495057",
                        },
                      },
                      rows: {
                        style: {
                          fontSize: "0.9rem",
                          "&:hover": {
                            backgroundColor: "#f8f9fa",
                          },
                        },
                      },
                    }}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Help Text */}
          <Row className="mt-4">
            <Col>
              <Card className="border-0 bg-light">
                <Card.Body>
                  <h6 className="fw-bold mb-2">
                    <i className="fas fa-info-circle me-2 text-info"></i>
                    Quick Guide
                  </h6>
                  <div className="row">
                    <div className="col-md-6">
                      <ul className="small mb-0">
                        <li>
                          Supported formats: Excel (.xlsx, .xls) and CSV files
                        </li>
                        <li>Maximum file size: 50MB</li>
                        <li>First row must contain column headers</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="small mb-0">
                        <li>
                          Failed records can be downloaded and re-uploaded
                        </li>
                        <li>Templates can be saved for recurring imports</li>
                        <li>
                          Processing happens in background for large files
                        </li>
                      </ul>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
